import Helpers from './Helpers.js';

/**
 * Book — the Chili Piper hosted scheduler side of the bar (the panel
 * iframe loading Config.bookingUrl). The hosted booking page posts events
 * to the parent window (same postMessage protocol CP's own concierge
 * client consumes) — init() listens for them: the spinner hides on the
 * real "slots rendered" signal instead of the iframe's load event, and
 * booking-confirmed is the Book-attribution hook point.
 */

var Book = new Object();

/**
 * Spinner fallback timer — if the scheduler page never posts
 * availability-loaded (CP outage, protocol change), don't spin forever.
 */
Book.spinnerFallbackTimer = null;

/**
 * Run-once guard for the window message listener (armed by init).
 */
Book.listening = false;

/**
 * Arm the window message listener (called once from Component.init; the
 * scheduler iframe itself only mounts on first Book click).
 *
 * @param {object} component  Alpine component
 */
Book.init = function (component) {

  var _this = this;

  if (_this.listening) return;

  _this.listening = true;

  window.addEventListener('message', function (event) {

    // Only the CP booking page's messages; the chat widget's loader
    // messages ({ type, value } from chili-chat-embed) are CP-internal
    // and stay out of here.
    if (String(event.origin).indexOf('chilipiper.com') === -1) return;

    var action = event.data && event.data.action;

    if (!action) return;

    _this.widgetEvent(component, event.data);

  });

};

/**
 * CP booking widget events, posted by the hosted scheduler page.
 * Placeholder hook points, log only until tracking is speced. Known
 * actions (from CP's concierge client dispatch table + observed live):
 *
 *   availability-loaded  slots grid rendered (observed on panel open)
 *   booking-confirmed    the visitor booked a meeting
 *   close                the widget's own close affordance
 *   error                booking/routing error
 *
 * @param {object} component  Alpine component
 * @param {object} data       { action, args } from the scheduler iframe
 */
Book.widgetEvent = function (component, data) {

  var _this = this;

  Helpers.log(component, 'book widget event', data);

  switch (data.action) {

    // Slots rendered — the real "content ready" signal (fires after the
    // iframe's load event, once CP has fetched availability).
    case 'availability-loaded':
      clearTimeout(_this.spinnerFallbackTimer);
      component.bookFrameLoading = false;
      break;

    // The Book-attribution conversion moment — a demo booked in the panel.
    // When tracking is speced, dispatch here so GTM can pick it up, e.g.:
    // Helpers.dispatch('connect_bar_book_booking', { event: 'connect_bar_book_booking', page_url: window.location.href });
    case 'booking-confirmed':
      break;

    // The widget's own close affordance (not shown in the panel embed
    // today — the panel header's X is ours).
    case 'close':
      break;

    // Booking/routing error inside the scheduler.
    case 'error':
      break;

  }

};

/**
 * Iframe load event (bound in book-panel.php). The CP page is fetched but
 * availability isn't rendered yet — keep the spinner until
 * availability-loaded arrives, with a fallback so a CP hiccup can't spin
 * it forever.
 *
 * @param {object} component  Alpine component
 */
Book.frameLoaded = function (component) {

  var _this = this;

  clearTimeout(_this.spinnerFallbackTimer);

  _this.spinnerFallbackTimer = setTimeout(function () {

    if (!component.bookFrameLoading) return;

    Helpers.log(component, 'Book.frameLoaded — no availability-loaded within grace period, hiding spinner');

    component.bookFrameLoading = false;

  }, 5000);

};

export default Book;
